import { onAuthStateChanged, signOut } from "firebase/auth";
import React, { createContext, useEffect, useReducer } from "react";
import { auth } from "./firebase";

export const AuthContext = createContext({});

const initialState = {
    id: null,
    user: null,
    isSignIn: false,
}




const reducer = (state, action) => {
    switch (action.type) {
        case "SET_ID":
            return {...state, id : action.payload }
        case "SET_USER":
            return {...state, user : action.payload }
        case "SET_ISSIGNIN":
            return {...state, isSignIn : action.payload }
        default:
            break;
    }
}

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    const { user, isSignIn } = state;
    //const setUserID = payload => dispatch({ type : 'SET_ID', payload })
    const setUser = payload => dispatch({ type : 'SET_USER', payload })
    const setSignIn = payload => dispatch({ type : 'SET_ISSIGNIN', payload })

    //const isSignIn = () => id === null ? false : true

    // useEffect(() => {
    //     console.log(id)
    // }, [id])

    useEffect(() => {
        onAuthStateChanged(auth, u => {
            setUser(u)
            setSignIn(u ? true : false)
            if (u) {
                const timeout = setTimeout(async () => {
                    await signOut(auth);
                    setUser(null)
                    setSignIn(false)
                    alert("Session expired. You have been signed out.");
                }, 30 * 60 * 1000);
                return () => clearTimeout(timeout);
            }
        })
    }, [])

    return (
        <AuthContext.Provider value={{ user, setUser, isSignIn }}>
            {children}
        </AuthContext.Provider>
    )
}